<script>
	import FixedButtons from './components/FixedButtons.svelte';
	import ChartsSelector from './components/ChartsSelector.svelte';
    import {onMount} from 'svelte';
    import router from 'page';

    import Loader from "./components/Loader.svelte";
    import MonthSelector from './components/MonthSelector.svelte';
    import NavBar from './components/NavBar.svelte';
    import OrgSelector from './components/OrgSelector.svelte';
    import ReportMenus from './components/ReportMenus.svelte';
    import YearSelector from './components/YearSelector.svelte';

    import Dashboard from './pages/Dashboard.svelte';
    import Error from './pages/Error.svelte';
    import Help from './pages/Help.svelte';
    import Permissions from './pages/Permissions.svelte';
    import TrashBin from './pages/TrashBin.svelte';
    import Alteryx from './operations_kpis/pages/Alteryx.svelte';

    import Home from './pages/Home.svelte';
    import Login from './pages/Login.svelte';
    import Individual from './operations_kpis/pages/Individual.svelte';
    import Monthly from './operations_kpis/pages/Monthly.svelte';
    // import Individual from './pages/Employees.svelte';
    import Charts from './pages/Charts.svelte';

    import menusService from './operations_kpis/services/menus.service.js';
    import AuthService from './services/auth.service.js';
    import OrganizationsService from "./services/organizations.service";
    import WeekDaySelector from "./components/WeekDaySelector.svelte";
    import ReportsService from "./services/reports.service";
    import CookiesService from './services/cookies.service.js';
    import QuarterSelector from './operations_kpis/components/QuarterSelector.svelte';

    let page, params, user, loading = true,
        organizations, options, showMenu = false, staticPage = false,
        buildNumber = window.buildNumber, hrDisabledUsers = [], organizationsCodes, component;

    //Org and menu are objects and the other are strings
    $: options = {
        'org': {
            'id': '',
            'name': '',
            'is_active': null
        },
        'weekday': 1,
        'year': '',
        'month': '',
        'rollingMonth': null,
        'menu': {
            'title': '',
            'url': '',
            'default': '',
            'subMenus': []
        },
        'subMenu': '',
        'chartOrgs': ""
    };

    $: organizations = [];

    //Get org data from org param
    function getOrg(orgId) {
        var org = organizations.filter((o) => o.id == orgId);
        return (org.length == 1) ? org[0] : organizations[0];
    }

    //Get report type as object from param
    function getMenu(urlParam) {
        var menu = menusService.filter((m) => m.url == urlParam);
        return (menu.length == 1) ? menu[0] : menusService[0];
    }

    //Get report sub type as string
    function getSubMenu(param) {
        var subMenu = options.menu.subMenus.filter((s) => s.url == param);
        return (subMenu.length == 1) ? subMenu[0].url : options.menu.default;
    }

    function loadParams() {
        var today = new Date();
        console.log('params: ', params);
        const isActualVsBudgets = window.location.href.includes('actuals_vs_budget');
        if (!params) {
            if (organizations[0]) {
                options = {
                    'org': organizations[0],
                    'year': today.getFullYear(),
                    'month': isActualVsBudgets? getCurrentQuarter() : today.getMonth() +1,
                    'rollingMonth' : null,
                    'menu': null,
                    'subMenu': menusService[0].default.replace('/', ''),
                    'weekday': 1,
                    'chartOrgs': organizations[0].id.toString()
                }
            }
        } else {
            //Assign org
            options.org = getOrg(params.org);

            //Assign year
            if (params.year == today.getFullYear() || params.year == today.getFullYear() - 1) {
                options.year = params.year;
            } else {
                options.year = today.getFullYear();
            }

            //Assign month
            if ( (!isActualVsBudgets && params.month > 0 && params.month < 13) || 
                (isActualVsBudgets && params.month > 0 && params.month < 5) )
                options.month = params.month;

            //Get menu as object
            var urlPathName = window.location.pathname.split('/')[1];
            options.menu = getMenu(urlPathName);

            //Asign subMenu
            options.subMenu = getSubMenu(params.subMenu);

            //Asign chart orgs list
            if(options.menu.url == "charts"){
                options.chartOrgs = params.org;
            }

            options.rollingMonth = params.ptqr_rolling_month;
            console.log('params: ', options);
        }

        // RRAS Tasks / Export
        let lmsOrg, orgFound;
        if (lmsOrg = CookiesService.get('rras_export_org')) {
            if( orgFound = organizations.filter((o) => o.lms_id == lmsOrg)) {
                CookiesService.set('rras_export_org','',365);
                // Redirect to rras organization
                let newUrl = window.location.href.split('/');
                newUrl[4] = orgFound[0].id;
                window.location.href = newUrl.join('/');
            }
        }
    }

    onMount(async () => {
        await AuthService.init();
        user = AuthService.getUser();

        if (user.id) {
            await OrganizationsService.init();
            organizations = OrganizationsService.list();
            let orgCodesResponse = null;
            orgCodesResponse = await OrganizationsService.getOrganizationsCodes();
            if(orgCodesResponse && orgCodesResponse.data) organizationsCodes = orgCodesResponse.data;
            loadParams();
        }

        loading = false;
    });

    function getCurrentQuarter() {
        const currentMonth = new Date().getMonth() + 1;
        const MONTHS = 12;
        const QUARTERS = 4;
        const currentQuarter = Math.abs(Math.ceil( (MONTHS - currentMonth) / QUARTERS) - QUARTERS );
        return currentQuarter;
    }

    function logout() {
        organizations = false;
        user = undefined;
        loading = true;
        AuthService.logout();
    }

    function intercept(ctx, next) {
        params = ctx.params;
        showMenu = true;
        next();
    }

    function startDayChanged(){
        params.subMenu = "1";
        params.subMenu = "";
    }

    function rollingMonthChanged(subMenu) {
        params.subMenu = subMenu;
    }

    // General routes
    router('/', () => {
        if (window.location.href.indexOf('?v=') > 0) {
            page = Dashboard;
            showMenu = true;
        } else {
            window.location = '/?v=' + Math.floor(Date.now() / 1000);
        }
    });

    router('/dashboard', () => {
        page = Dashboard;
        showMenu = true;
        var today = new Date();
        options = {
            'org': organizations && organizations[0]? organizations[0]: 0,
            'year': today.getFullYear(),
            'month': today.getMonth(),
            'menu': null,
            'subMenu': menusService[0].default.replace('/', ''),
            'weekday': 1,
        };
    });

    router('/permissions', () => {
        showMenu = false;
        page = Permissions;
    });

    router('/trashbin',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = TrashBin);

    router('/alteryx',
            (ctx, next) => {
                params = ctx.params;
                showMenu = false;
                next();
            },
            () => page = Alteryx);

    // Authentication
    router('/logout', logout);
    router('/login', () => {
        if (ENVIRONMENT.DEBUG === 'true') {
            page = Login;
        } else {
            window.location = ENVIRONMENT.API_HOST + '/external-login';
        }
    } );

    // Reports routes
    router('/weekly/:org?/:year?/:month?', intercept, () => page = Weekly);
    router('/monthly/:org?/:subMenu?/:year?/:month?', intercept, () => page = Monthly);
    router('/employees/:org?/:subMenu?/:year?/:month?', intercept, () => page = Individual);
    // Charts
    router('/charts/:org?/:subMenu?/:year?/:month?', intercept, () => page = Charts);

    //Riverside home page
    router('/home', () => {
        staticPage = true;
        page = Home;
    });
    // Documentation routes
    router('/help/:section',
        (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = Help);

    // Not found / Error route
    router('/*', (ctx, next) => {
            params = ctx.params;
            showMenu = false;
            next();
        },
        () => page = Error);
    router.start();

    async function pasteController() {
        let data = jQuery('#pasteController').data();
        if (data.paste) {
            if (jQuery('.hr-report').length > 0){
                //Paste HR data
                console.log(data.paste);
                await ReportsService.hrPasting(data.paste, params.org);
                jQuery('#reloadData').trigger('click');
            } else {
                //Paste KPIS data
                let payload = [];
                let report = '';

                data.paste.map( cell => {
                    let newCell = {
                        date: cell.date,
                        locked: false,
                        notes: 'pasted'
                    };

                    if (cell.field) {
                        report = cell.report;
                        if (cell.field === 'actual') newCell.actual = cell.value;
                        if (cell.field === 'yearly_actuals') newCell.actual = cell.value;
                        if (cell.field === 'budget') newCell.budget = cell.value;
                        if (cell.field === 'performance') newCell.performance = cell.value;
                        if (cell.field === 'quota') newCell.quota = cell.value;
                        if (cell.field === 'pipeline') newCell.pipeline = cell.value;

                        if (cell.report === 'employee') {
                            newCell.employee_id = cell.id;
                            if(cell.attainment_header){
                                newCell.field = cell.field;
                                newCell.value = cell.value;
                            }
                        } else {
                            newCell.kpi_id = cell.id;
                        }

                        payload.push(newCell);
                    }
                });

                await ReportsService.paste(payload, report, params.org);
                jQuery('#reloadData').trigger('click');
            }
        }
    }
</script>
<button id="pasteController" style="display: none;" on:click={pasteController}>PASTE</button>

{#if !staticPage}
    <NavBar bind:user={user}></NavBar>
    <div id="main-div" class="px-3">
        {#if loading}
            <Loader></Loader>
        {:else}
            {#if user && showMenu == true }
                <ReportMenus menus={menusService} bind:options={options} bind:params={params} />
                {#if options.menu}
                    <div class="row pb-3" id="report-options">
                        <div class="col">
                            <div class="row">
                                {#if options.menu.url == 'charts'}
                                    <ChartsSelector bind:options={options} bind:params={params} />
                                {/if}

                                {#if params && window.location.pathname.split('/')[3] !== 'staffing-agregate'}
                                    <OrgSelector codes={organizationsCodes} organizations={organizations} bind:options={options} bind:params={params} />
                                {:else}
                                    <div class="offset-2 col-md-3 mt-3">
                                        <div id="dropdownOrganizations" class="btn text-left">ALL PORTCO'S</div>
                                    </div>
                                {/if}

                                {#if params && (window.location.pathname.split('/')[1] == 'weekly')}
                                    {#if AuthService.can('SHOW_WEEKDAY_SELECTOR') }
                                        <WeekDaySelector bind:options={options} on:dayChanged={ () => startDayChanged() } />
                                    {/if}
                                {/if}

                                <YearSelector bind:options={options} />

                                {#if params && window.location.href.includes('actuals_vs_budget')}
                                    <QuarterSelector bind:options={options} />
                                {/if}

                                {#if params && (window.location.pathname.split('/')[1] == 'weekly' || params.subMenu == 'summary')}
                                    <MonthSelector bind:options={options} />
                                {/if}

                            </div>
                        </div>
                    </div>
                    {#if params && (window.location.pathname.split('/')[1] != 'hr')}
                        <FixedButtons
                            bind:component={component}
                            on:exportReport={(report) => component.exportToExcel(report.detail.all_portcos)}
                            on:indicatorsRemoved={component.loadData}
                            on:addSection={component.addSection}
                        ></FixedButtons>
                    {/if}
                {/if}
            {/if}
            {#if params && (window.location.pathname.split('/')[1] != 'hr')}
                <div id="{(user && showMenu == true) ? 'reportsDiv': ''}" class="{(params) ? (window.location.pathname.split('/')[1] == 'weekly'? 'reports-weekly' : ''):'reports-dashboard'}">
                    <svelte:component this={page} bind:this={component} params={params} bind:user={user} bind:options={options}></svelte:component>
                </div>
            {:else}
                <!-- Use reportDiv inside HR component / page -->
                <svelte:component this={page} bind:this={component} params={params} bind:user={user} bind:options={options}></svelte:component>
            {/if}
        {/if}
    </div>

    <footer class="text-center text-muted" on:click={() => window.location = '/?v=' + Date.now()}>
        <small>Copyright 2020 Riverside Company - Build: {buildNumber}</small>
    </footer>

{:else}
    <svelte:component this={page} bind:this={component} params={params}></svelte:component>
{/if}
